export const APP_STARTED = 'APP_STARTED';
export const HIDE_LOADING = 'HIDE_LOADING';
export const SHOW_LOADING = 'SHOW_LOADING';
export const CANCEL_SCHEDULED_EMAIL_ERROR = 'CANCEL_SCHEDULED_EMAIL_ERROR';
export const FETCH_USER_ATTRIBUTES_STARTED = 'FETCH_USER_ATTRIBUTES_STARTED';
export const FETCH_USER_ATTRIBUTES_SUCCEEDED = 'FETCH_USER_ATTRIBUTES_SUCCEEDED';
export const FETCH_USER_ATTRIBUTES_FAILED = 'FETCH_USER_ATTRIBUTES_FAILED';
export const FETCH_HUB_SETTINGS_SUCCEEDED = 'FETCH_HUB_SETTINGS_SUCCEEDED';
export const TOGGLE_UNPUBLISH_MODAL = 'TOGGLE_UNPUBLISH_MODAL';
export const TOGGLE_PERSONALIZATION_EDITOR_MODAL = 'TOGGLE_PERSONALIZATION_EDITOR_MODAL';
export const TOGGLE_REVIEW_MODAL = 'TOGGLE_REVIEW_MODAL';
export const TOGGLE_PUBLISH_MODAL_OPEN = 'TOGGLE_PUBLISH_MODAL_OPEN';
export const TOGGLE_PUBLISH_OPTIONS_MODAL_OPEN = 'TOGGLE_PUBLISH_OPTIONS_MODAL_OPEN';
export const TOGGLE_RUN_TEST_MODAL = 'TOGGLE_RUN_TEST_MODAL';
export const TOGGLE_POST_PUBLISH_DOMAIN_SETUP_MODAL = 'TOGGLE_POST_PUBLISH_DOMAIN_SETUP_MODAL';
export const LOG_SENTRY_WITH_HISTORY = 'LOG_SENTRY_WITH_HISTORY';
export const SNAPSHOT_STATE_IN_TIME = 'SNAPSHOT_STATE_IN_TIME';
export const UPDATE_USER_ATTRIBUTE = 'UPDATE_USER_ATTRIBUTE';
export const UPDATE_HUB_SETTING = 'UPDATE_HUB_SETTING';
export const UPDATE_USER_ATTRIBUTE_ALSO_CACHED_IN_SUPERSTORE = 'UPDATE_USER_ATTRIBUTE_ALSO_CACHED_IN_SUPERSTORE';
export const UPDATE_SUPERSTORE_USER_SETTING = 'UPDATE_SUPERSTORE_USER_SETTING';
export const UPDATE_SUPERSTORE_PER_CONTENT_SETTING = 'UPDATE_SUPERSTORE_PER_CONTENT_SETTING';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_POPOVER = 'OPEN_POPOVER';
export const CLOSE_POPOVER = 'CLOSE_POPOVER';
export const OPEN_POPOUT_EDITOR = 'OPEN_POPOUT_EDITOR';
export const CLOSE_POPOUT_EDITOR = 'CLOSE_POPOUT_EDITOR';
export const DISPLAY_EXIT_PREVIEW_AND_LAYOUT_BUTTON = 'DISPLAY_EXIT_PREVIEW_AND_LAYOUT_BUTTON';
export const CLOSE_EXIT_PREVIEW_AND_LAYOUT_BUTTON = 'CLOSE_EXIT_PREVIEW_AND_LAYOUT_BUTTON';
export const I18N_READY = 'I18N_READY';
export const SET_IFRAME_LOADING = 'SET_IFRAME_LOADING';
export const SET_IFRAME_READY = 'SET_IFRAME_READY';
export const SET_IFRAME_RENDERED = 'SET_IFRAME_RENDERED';
export const SET_IFRAME_NEEDS_REFRESH = 'SET_IFRAME_NEEDS_REFRESH';
export const SET_IFRAME_HIDDEN = 'SET_IFRAME_HIDDEN';
export const SET_IFRAME_FAILED = 'SET_IFRAME_FAILED';
export const SET_ADD_MODULE_SIDEBAR_LOADED = 'SET_ADD_MODULE_SIDEBAR_LOADED';
export const SET_FLEX_AREA_INDEX = 'SET_FLEX_AREA_INDEX';
export const NAVIGATION_TO_SAME_PAGE = 'NAVIGATION_TO_SAME_PAGE';
export const NAVIGATE_TO_PREVIEW = 'NAVIGATE_TO_PREVIEW';
export const FORCE_SHOW_END_TEST_MODAL = 'FORCE_SHOW_END_TEST_MODAL';
export const FETCH_SUPPRESSED_CONTACTS_COUNT_SUCCESS = 'FETCH_SUPPRESSED_CONTACTS_COUNT_SUCCESS';
export const FETCH_SUPPRESSED_CONTACTS_COUNT_FAIL = 'FETCH_SUPPRESSED_CONTACTS_COUNT_FAIL';
export const FETCH_SELECTED_CONTACTS_COUNT_FAIL = 'FETCH_SELECTED_CONTACTS_COUNT_FAIL';
export const FETCH_ALL_RECIPIENT_COUNTS_START = 'FETCH_ALL_RECIPIENT_COUNTS_START';
export const FETCH_ALL_RECIPIENT_COUNTS_SUCCESS = 'FETCH_ALL_RECIPIENT_COUNTS_SUCCESS';
export const FETCH_ALL_RECIPIENT_COUNTS_FAIL = 'FETCH_ALL_RECIPIENT_COUNTS_FAIL';
export const FETCH_LISTS_SUCCESS = 'FETCH_LISTS_SUCCESS';
export const FETCH_LISTS_FAIL = 'FETCH_LISTS_FAIL';
export const FETCH_CONTACTS_SUCCESS = 'FETCH_CONTACTS_SUCCESS';
export const FETCH_CONTACTS_FAIL = 'FETCH_CONTACTS_FAIL';
export const RECIPIENTS_UPDATED = 'RECIPIENTS_UPDATED';
export const START_RECIPIENTS_FETCH = 'START_RECIPIENTS_FETCH';
export const UPDATE_GRAYMAIL_SUPPRESSION = 'UPDATE_GRAYMAIL_SUPPRESSION';
export const SUPPRESSION_CHECK_FAILED = 'SUPPRESSION_CHECK_FAILED';
export const SUPPRESSION_CHECK_SUCCESS = 'SUPPRESSION_CHECK_SUCCESS';
export const RESET_SEARCH_CONTACTS = 'RESET_SEARCH_CONTACTS';
export const RESET_SEARCH_LISTS = 'RESET_SEARCH_LISTS';
export const START_LIST_CREATION = 'START_LIST_CREATION';
export const COMPLETE_LIST_CREATION = 'COMPLETE_LIST_CREATION';
export const UPDATE_EMAIL_TYPE = 'UPDATE_EMAIL_TYPE';
export const PREVIEW_REQUEST_FAILED = 'PREVIEW_REQUEST_FAILED';
export const SET_PREVIEW_FILTERS_CONFIG = 'SET_PREVIEW_FILTERS_CONFIG';
export const FETCH_TEMPLATE_INFO_FAIL = 'FETCH_TEMPLATE_INFO_FAIL';
export const FETCH_TEMPLATE_INFO_REQUEST = 'FETCH_TEMPLATE_INFO_REQUEST';
export const FETCH_TEMPLATE_INFO_SUCCESS = 'FETCH_TEMPLATE_INFO_SUCCESS';
export const FETCH_TEMPLATE_PREVIEW_URL_REQUEST = 'FETCH_TEMPLATE_PREVIEW_URL_REQUEST';
export const FETCH_TEMPLATE_PREVIEW_URL_SUCCESS = 'FETCH_TEMPLATE_PREVIEW_URL_SUCCESS';
export const FETCH_TEMPLATE_PREVIEW_URL_FAIL = 'FETCH_TEMPLATE_PREVIEW_URL_FAIL';
export const FETCH_SUBSCRIPTION_DEFINITIONS_SUCCESS = 'FETCH_SUBSCRIPTION_DEFINITIONS_SUCCESS';
export const FETCH_SUBSCRIPTION_DEFINITIONS_FAIL = 'FETCH_SUBSCRIPTION_DEFINITIONS_FAIL';
export const FETCH_SUBSCRIPTION_GROUPS_STARTED = 'FETCH_SUBSCRIPTION_GROUPS_STARTED';
export const FETCH_SUBSCRIPTION_GROUPS_SUCCEEDED = 'FETCH_SUBSCRIPTION_GROUPS_SUCCEEDED';
export const FETCH_SUBSCRIPTION_GROUPS_FAILED = 'FETCH_SUBSCRIPTION_GROUPS_FAILED';
export const FETCH_EMAIL_SETTINGS_SLUG_REQUEST = 'FETCH_EMAIL_SETTINGS_SLUG_REQUEST';
export const FETCH_EMAIL_SETTINGS_SLUG_FAIL = 'FETCH_EMAIL_SETTINGS_SLUG_FAIL';
export const UNLINK_EMAIL_SLUG_FROM_TITLE = 'UNLINK_EMAIL_SLUG_FROM_TITLE';
export const SET_HAS_BEEN_EDITED_IN_EDITOR = 'SET_HAS_BEEN_EDITED_IN_EDITOR';
export const UPDATE_EMAIL_SETTING = 'UPDATE_EMAIL_SETTING';
export const UPDATE_RSS_SETTING = 'UPDATE_RSS_SETTING';
export const UPDATE_EMAIL_SETTINGS_SLUG_RAW = 'UPDATE_EMAIL_SETTINGS_SLUG_RAW';
export const UPDATE_CAN_SPAM_SETTING_ID = 'UPDATE_CAN_SPAM_SETTING_ID';
export const UPDATE_WEBVERSION_ENABLED = 'UPDATE_WEBVERSION_ENABLED';
export const UPDATE_CONTENT_MODEL_AI_FEATURES = 'UPDATE_CONTENT_MODEL_AI_FEATURES';
export const UPDATE_CAN_SPAM_SETTINGS_SUCCESS = 'UPDATE_CAN_SPAM_SETTINGS_SUCCESS';
export const UPDATE_CAN_SPAM_SETTINGS_FAIL = 'UPDATE_CAN_SPAM_SETTINGS_FAIL';
export const DELETE_CAN_SPAM_SETTING_SUCCESS = 'DELETE_CAN_SPAM_SETTING_SUCCESS';
export const DELETE_CAN_SPAM_SETTING_FAIL = 'DELETE_CAN_SPAM_SETTING_FAIL';
export const REQUEST_PREVIEW_EMAIL = 'REQUEST_PREVIEW_EMAIL';
export const UPDATE_PREVIEW_EMAIL = 'UPDATE_PREVIEW_EMAIL';
export const UPDATE_PREVIEW_CONTACT = 'UPDATE_PREVIEW_CONTACT';
export const UPDATE_PLATFORM_OPEN = 'UPDATE_PLATFORM_OPEN';
export const UPDATE_PREVIEW_PRODUCT_IDS = 'UPDATE_PREVIEW_PRODUCT_IDS';
export const START_RSS_VALIDATION = 'START_RSS_VALIDATION';
export const FETCH_RSS_VALIDATION_SUCCESS = 'FETCH_RSS_VALIDATION_SUCCESS';
export const FETCH_RSS_VALIDATION_ERROR = 'FETCH_RSS_VALIDATION_ERROR';
export const FETCH_EMAIL_PLAINTEXT_STARTED = 'FETCH_EMAIL_PLAINTEXT_STARTED';
export const FETCH_EMAIL_PLAINTEXT_SUCCESS = 'FETCH_EMAIL_PLAINTEXT_SUCCESS';
export const FETCH_EMAIL_PLAINTEXT_FAIL = 'FETCH_EMAIL_PLAINTEXT_FAIL';
export const SET_EDITOR_SETTINGS_SCROLL_TO = 'SET_EDITOR_SETTINGS_SCROLL_TO';
export const FETCH_CONTENT_STARTED = 'FETCH_CONTENT_STARTED';
export const FETCH_CONTENT_SUCCEEDED = 'FETCH_CONTENT_SUCCEEDED';
export const FETCH_CONTENT_FAILED = 'FETCH_CONTENT_FAILED';
export const FETCH_CONTENT_SCHEMA_FAILED = 'FETCH_CONTENT_SCHEMA_FAILED';
export const FETCH_CONTENT_SCHEMA_STARTED = 'FETCH_CONTENT_SCHEMA_STARTED';
export const FETCH_CONTENT_SCHEMA_SUCCEEDED = 'FETCH_CONTENT_SCHEMA_SUCCEEDED';
export const SEED_STAGED_PAGE_SETTINGS = 'SEED_STAGED_PAGE_SETTINGS';
export const FETCH_LAYOUT_DATA_STARTED = 'FETCH_LAYOUT_DATA_STARTED';
export const FETCH_LAYOUT_DATA_SUCCEEDED = 'FETCH_LAYOUT_DATA_SUCCEEDED';
export const FETCH_LAYOUT_DATA_FAILED = 'FETCH_LAYOUT_DATA_FAILED';
export const CLEAR_CONTENT_MODEL_FEATURED_IMAGE = 'CLEAR_CONTENT_MODEL_FEATURED_IMAGE';
export const UPDATE_CONTENT_MODEL_CAMPAIGN = 'UPDATE_CONTENT_MODEL_CAMPAIGN';
export const UPDATE_CONTENT_MODEL_CAMPAIGNS = 'UPDATE_CONTENT_MODEL_CAMPAIGNS';
export const UPDATE_CONTENT_MODEL_DOMAIN = 'UPDATE_CONTENT_MODEL_DOMAIN';
export const UPDATE_CONTENT_MODEL_EXPIRY_DATE = 'UPDATE_CONTENT_MODEL_EXPIRY_DATE';
export const UPDATE_CONTENT_MODEL_EXPIRY_ENABLED = 'UPDATE_CONTENT_MODEL_EXPIRY_ENABLED';
export const UPDATE_CONTENT_MODEL_EXPIRY_REDIRECT_URL = 'UPDATE_CONTENT_MODEL_EXPIRY_REDIRECT_URL';
export const UPDATE_CONTENT_MODEL_HTML_TITLE = 'UPDATE_CONTENT_MODEL_HTML_TITLE';
export const UPDATE_HEADER = 'UPDATE_HEADER';
export const UPDATE_FOOTER = 'UPDATE_FOOTER';
export const UPDATE_CONTENT_MODEL_META_DESCRIPTION = 'UPDATE_CONTENT_MODEL_META_DESCRIPTION';
export const UPDATE_CONTENT_MODEL_NAME = 'UPDATE_CONTENT_MODEL_NAME';
export const UPDATE_CONTENT_MODEL_SLUG = 'UPDATE_CONTENT_MODEL_SLUG';
export const UPDATE_CONTENT_MODEL_CANONICAL_URL = 'UPDATE_CONTENT_MODEL_CANONICAL_URL';
export const UPDATE_CONTENT_MODEL_TEMPLATE_PATH = 'UPDATE_CONTENT_MODEL_TEMPLATE_PATH';
export const UPDATE_CONTENT_MODEL_USE_FEATURED_IMAGE = 'UPDATE_CONTENT_MODEL_USE_FEATURED_IMAGE';
export const UPDATE_CONTENT_MODEL_FEATURED_IMAGE = 'UPDATE_CONTENT_MODEL_FEATURED_IMAGE';
export const UPLOAD_FEATURED_IMAGE = 'UPLOAD_FEATURED_IMAGE';
export const UPDATE_CONTENT_MODEL_THEME_PAGE_OVERRIDES = 'UPDATE_CONTENT_MODEL_THEME_PAGE_OVERRIDES';
export const CLEAR_UPDATED_THEME_SETTINGS = 'CLEAR_UPDATED_THEME_SETTINGS';
export const UPDATE_THEME_VARIANT = 'UPDATE_THEME_VARIANT';
export const FETCH_SETTINGS_SLUG_FAIL = 'FETCH_SETTINGS_SLUG_FAIL';
export const FETCH_SETTINGS_SLUG_REQUEST = 'FETCH_SETTINGS_SLUG_REQUEST';
export const UNLINK_SLUG_FROM_TITLE = 'UNLINK_SLUG_FROM_TITLE';
export const UPDATE_SETTINGS_SCHEDULE_DATE = 'UPDATE_SETTINGS_SCHEDULE_DATE';
export const UPDATE_SETTINGS_SHOW_ALL_ERRORS = 'UPDATE_SETTINGS_SHOW_ALL_ERRORS';
export const UPDATE_SETTINGS_SLUG_RAW = 'UPDATE_SETTINGS_SLUG_RAW';
export const SET_SETTINGS_SCROLL_TO = 'SET_SETTINGS_SCROLL_TO';
export const FETCH_SUPPORTED_LANGUAGES_FAILED = 'FETCH_SUPPORTED_LANGUAGES_FAILED';
export const FETCH_SUPPORTED_LANGUAGES_STARTED = 'FETCH_SUPPORTED_LANGUAGES_STARTED';
export const FETCH_SUPPORTED_LANGUAGES_SUCCEEDED = 'FETCH_SUPPORTED_LANGUAGES_SUCCEEDED';
export const UPDATE_RENDER_LANGUAGE = 'UPDATE_RENDER_LANGUAGE';
export const REQUEST_GLOBAL_MODULES = 'REQUEST_GLOBAL_MODULES';
export const FETCH_GLOBAL_MODULES_SUCCESS = 'FETCH_GLOBAL_MODULES_SUCCESS';
export const FETCH_GLOBAL_MODULES_FAIL = 'FETCH_GLOBAL_MODULES_FAIL';
export const REQUEST_CUSTOM_MODULES = 'REQUEST_CUSTOM_MODULES';
export const FETCH_CUSTOM_MODULES_SUCCESS = 'FETCH_CUSTOM_MODULES_SUCCESS';
export const FETCH_CUSTOM_MODULES_FAIL = 'FETCH_CUSTOM_MODULES_FAIL';
export const FETCH_MODULE_SCHEMAS_FAILED = 'FETCH_MODULE_SCHEMAS_FAILED';
export const FETCH_MODULE_SCHEMAS_STARTED = 'FETCH_MODULE_SCHEMAS_STARTED';
export const FETCH_MODULE_SCHEMAS_SUCCEEDED = 'FETCH_MODULE_SCHEMAS_SUCCEEDED';
export const REHYDRATE_MODULE_SCHEMAS_FAILED = 'REHYDRATE_MODULE_SCHEMAS_FAILED';
export const BATCH_FETCH_MODULE_SCHEMAS_STARTED = 'BATCH_FETCH_MODULE_SCHEMAS_STARTED';
export const BATCH_FETCH_MODULE_SCHEMAS_SUCCEEDED = 'BATCH_FETCH_MODULE_SCHEMAS_SUCCEEDED';
export const BATCH_FETCH_MODULE_SCHEMAS_FAILED = 'BATCH_FETCH_MODULE_SCHEMAS_FAILED';
export const REHYDRATE_MODULE_SCHEMAS_STARTED = 'REHYDRATE_MODULE_SCHEMAS_STARTED';
export const REHYDRATE_MODULE_SCHEMAS_SUCCEEDED = 'REHYDRATE_MODULE_SCHEMAS_SUCCEEDED';
export const SET_ADD_PANEL_DISABLED_MODULES = 'SET_ADD_PANEL_DISABLED_MODULES';
export const CONTENT_SAVE_REQUEST_FAILED = 'CONTENT_SAVE_REQUEST_FAILED';
export const CONTENT_SAVE_REQUEST_STARTED = 'CONTENT_SAVE_REQUEST_STARTED';
export const CONTENT_SAVE_REQUEST_SUCCEEDED = 'CONTENT_SAVE_REQUEST_SUCCEEDED';
export const CONTENT_PUBLISH_REQUEST_FAILED = 'CONTENT_PUBLISH_REQUEST_FAILED';
export const CONTENT_PUBLISH_REQUEST_STARTED = 'CONTENT_PUBLISH_REQUEST_STARTED';
export const CONTENT_PUBLISH_REQUEST_SUCCEEDED = 'CONTENT_PUBLISH_REQUEST_SUCCEEDED';
export const PERMANENTLY_DISABLE_SAVING = 'PERMANENTLY_DISABLE_SAVING';
export const SET_DIRTY_FLAG = 'SET_DIRTY_FLAG';
export const SET_MODULES = 'SET_MODULES';
export const DELETED_MODULE = 'DELETED_MODULE';
export const CLOSE_DELETE_REQUEST_MODAL = 'CLOSE_DELETE_REQUEST_MODAL';
export const REQUESTED_MODULE_DELETE = 'REQUESTED_MODULE_DELETE';
export const ADDED_MODULE = 'ADDED_MODULE';
export const ADDED_MODULES_TO_FAKE_MODULES = 'ADDED_MODULES_TO_FAKE_MODULES';
export const ADDED_MODULES_TO_POST_BODY = 'ADDED_MODULES_TO_POST_BODY';
export const ADDED_CUSTOM_UPDATES_FOR_FAKE_MODULES = 'ADDED_CUSTOM_UPDATES_FOR_FAKE_MODULES';
export const MOVED_MODULE = 'MOVED_MODULE';
export const SAVED_MODULE = 'SAVED_MODULE';
export const UPDATED_CONTAINERS_FROM_PREVIEW = 'UPDATED_CONTAINERS_FROM_PREVIEW';
export const SET_MODULE_BODY = 'SET_MODULE_BODY';
export const MERGE_MODULE_BODY = 'MERGE_MODULE_BODY';
export const MERGE_GRID_MODULE_BODY = 'MERGE_GRID_MODULE_BODY';
export const MERGE_MODULE_DATA = 'MERGE_MODULE_DATA';
export const EDIT_FORM_FOLLOWUP_EMAIL = 'EDIT_FORM_FOLLOWUP_EMAIL';
export const LAYOUT_SECTION_SET_LABEL = 'LAYOUT_SECTION_SET_LABEL';
export const SCROLL_TO_LAYOUT_FRAGMENT = 'SCROLL_TO_LAYOUT_FRAGMENT';
export const MERGE_PREVIEW_TEXT_MODULE_BODY = 'MERGE_PREVIEW_TEXT_MODULE_BODY';
export const MERGE_MODULE_META_DATA = 'MERGE_MODULE_META_DATA';
export const SET_MODULE_SMART_OBJECT_BODY = 'SET_MODULE_SMART_OBJECT_BODY';
export const MERGE_MODULE_SMART_OBJECT_BODY = 'MERGE_MODULE_SMART_OBJECT_BODY';
export const SET_MODULE_BREAKPOINT_STYLES = 'SET_MODULE_BREAKPOINT_STYLES';
export const SET_MODULE_STYLES = 'SET_MODULE_STYLES';
export const REMOVE_FAKE_BODY_MODULE_STYLES = 'REMOVE_FAKE_BODY_MODULE_STYLES';
export const UPDATED_MODULE_SMART_RULES = 'UPDATED_MODULE_SMART_RULES';
export const REMOVED_MODULE_SMART_RULES = 'REMOVED_MODULE_SMART_RULES';
export const RESYNCHRONIZE_MODULE_SMART_OBJECTS = 'RESYNCHRONIZE_MODULE_SMART_OBJECTS';
export const SET_DEPRECATED_STYLES_FLAGS = 'SET_DEPRECATED_STYLES_FLAGS';
export const MODULE_REDUCER_CHANGE_UNDO = 'MODULE_REDUCER_CHANGE_UNDO';
export const MODULE_REDUCER_CHANGE_REDO = 'MODULE_REDUCER_CHANGE_REDO';
export const MODULE_REDUCER_CLEAR_UNDO_REDO = 'MODULE_REDUCER_CLEAR_UNDO_REDO';
export const INITIALIZE_FAKE_UNDOABLE_ITEMS = 'INITIALIZE_FAKE_UNDOABLE_ITEMS';
export const UPDATE_FAKE_UNDOABLE_ITEMS = 'UPDATE_FAKE_UNDOABLE_ITEMS';
export const EDIT_SIDEBAR_ACTIVE_TAB_UPDATED = 'EDIT_SIDEBAR_ACTIVE_TAB_UPDATED';
export const SELECTED_ITEM_CLEARED = 'SELECTED_ITEM_CLEARED';
export const SELECTED_ITEM_UPDATED = 'SELECTED_ITEM_UPDATED';
export const SELECTED_ITEM_UPDATED_STYLE_SECTION_TOUR_STEP = 'SELECTED_ITEM_UPDATED_STYLE_SECTION_TOUR_STEP';
export const SELECTED_ITEM_REVERTED_TO_PREVIOUS = 'SELECTED_ITEM_REVERTED_TO_PREVIOUS';
export const SELECT_BREAKPOINT = 'SELECT_BREAKPOINT';
export const TOGGLE_HIDDEN_ELEMENT_VISIBILITY = 'TOGGLE_HIDDEN_ELEMENT_VISIBILITY';
export const SET_BREAKPOINT_STYLES_FOR_TREE_NODE = 'SET_BREAKPOINT_STYLES_FOR_TREE_NODE';
export const UPDATE_DEVICE_WHEN_LAYOUT_SIDEBAR_OPEN = 'UPDATE_DEVICE_WHEN_LAYOUT_SIDEBAR_OPEN';
export const SELECT_MODULE_IN_LAYOUT_AREA_IN_MOBILE = 'SELECT_MODULE_IN_LAYOUT_AREA_IN_MOBILE';
export const ADD_PAGES = 'ADD_PAGES';
export const FETCH_PAGE_FAIL = 'FETCH_PAGE_FAIL';
export const FETCH_PAGE_REQUEST = 'FETCH_PAGE_REQUEST';
export const FETCH_PAGE_SUCCESS = 'FETCH_PAGE_SUCCESS';
export const SEARCH_PAGES_FAILURE = 'SEARCH_PAGES_FAILURE';
export const SEARCH_PAGES_REQUEST = 'SEARCH_PAGES_REQUEST';
export const UPDATE_PAGE_CONTENT_MODEL_CSS = 'UPDATE_PAGE_CONTENT_MODEL_CSS';
export const FETCH_PAGE_CSS_REQUEST = 'FETCH_PAGE_CSS_REQUEST';
export const FETCH_PAGE_CSS_SUCCESS = 'FETCH_PAGE_CSS_SUCCESS';
export const FETCH_PAGE_CSS_FAILED = 'FETCH_PAGE_CSS_FAILED';
export const OPTIMISTICALLY_ADD_CSS_ASSET = 'OPTIMISTICALLY_ADD_CSS_ASSET';
export const UPDATE_EDITOR_RENDERED_CSS_ASSET = 'UPDATE_EDITOR_RENDERED_CSS_ASSET';
export const OPENED_PANEL = 'OPENED_PANEL';
export const CLOSED_PANEL = 'CLOSED_PANEL';
export const OPENED_PREVIOUS_PANEL = 'OPENED_PREVIOUS_PANEL';
export const OPENED_PATAGONIA_SIDEBAR = 'OPENED_PATAGONIA_SIDEBAR';
export const CLOSED_PATAGONIA_SIDEBAR = 'CLOSED_PATAGONIA_SIDEBAR';
export const PATAGONIA_SIDEBAR_ANIMATION_FINISHED = 'PATAGONIA_SIDEBAR_ANIMATION_FINISHED';
export const UPDATE_PUBLISH_DATE = 'UPDATE_PUBLISH_DATE';
export const UPDATE_PUBLISH_IMMEDIATELY = 'UPDATE_PUBLISH_IMMEDIATELY';
export const SET_MODULE_ERRORS = 'SET_MODULE_ERRORS';
export const UPDATE_SITE_SETTINGS = 'UPDATE_SITE_SETTINGS';
export const UPDATE_SITE_SETTINGS_DOMAIN_LANGUAGE = 'UPDATE_SITE_SETTINGS_DOMAIN_LANGUAGE';
export const UPDATE_SITE_SETTINGS_FAILED = 'UPDATE_SITE_SETTINGS_FAILED';
export const UPDATE_SITE_SETTINGS_STARTED = 'UPDATE_SITE_SETTINGS_STARTED';
export const UPDATE_SITE_SETTINGS_SUCCEEDED = 'UPDATE_SITE_SETTINGS_SUCCEEDED';
export const CLEAR_SMART_VIEW = 'CLEAR_SMART_VIEW';
export const UPDATE_SMART_VIEW = 'UPDATE_SMART_VIEW';
export const UPDATE_EDITING_INFO = 'UPDATE_EDITING_INFO';
export const EDIT_FORM_VALIDATION_FINISHED = 'EDIT_FORM_VALIDATION_FINISHED';
export const LEGACY_EVENT_SET_MODE = 'LEGACY_EVENT_SET_MODE';
export const INPAGE_UI_STATE_CLEARED = 'INPAGE_UI_STATE_CLEARED';
export const RESET_HIGHLIGHTED_WIDGET_ID = 'RESET_HIGHLIGHTED_WIDGET_ID';
export const SYNC_INAPP_STATE = 'SYNC_INAPP_STATE';
export const UPDATE_FOCUSED_WIDGET_ID = 'UPDATE_FOCUSED_WIDGET_ID';
export const UPDATE_HIGHLIGHTED_WIDGET_ID = 'UPDATE_HIGHLIGHTED_WIDGET_ID';
export const UPDATE_INPAGE_IS_DRAGGING_MODULE = 'UPDATE_INPAGE_IS_DRAGGING_MODULE';
export const UPDATE_INPAGE_MODE = 'UPDATE_INPAGE_MODE';
export const UPDATE_POST_BODY = 'UPDATE_POST_BODY';
export const UPDATE_POST_CONTENT_MODEL_TITLE = 'UPDATE_POST_CONTENT_MODEL_TITLE';
export const UPDATE_SCROLL_TO_MODULE_ID = 'UPDATE_SCROLL_TO_MODULE_ID';
export const CLEAR_SCROLL_TO_NODE_POSITION_INFO = 'CLEAR_SCROLL_TO_NODE_POSITION_INFO ';
export const UPDATE_TITLE_FROM_INLINE = 'UPDATE_TITLE_FROM_INLINE';
export const PREVIEW_VIEWPORT_DIMENSIONS_UPDATED = 'PREVIEW_VIEWPORT_DIMENSIONS_UPDATED';
export const PREVIEW_WRAPPER_SCROLL_UPDATED = 'PREVIEW_WRAPPER_SCROLL_UPDATED';
export const INPAGE_PREVIEW_UNEXPECTEDLY_UNLOADED = 'INPAGE_PREVIEW_UNEXPECTEDLY_UNLOADED';
export const TRACKED_FAILED_INPAGE_ASSETS = 'TRACKED_FAILED_INPAGE_ASSETS';
export const TRACKED_INPAGE_JS_LOADING_MULTIPLE_TIMES = 'TRACKED_INPAGE_JS_LOADING_MULTIPLE_TIMES';
export const DOM_READY_BLOCKING_RESOURCE_DETECTED = 'DOM_READY_BLOCKING_RESOURCE_DETECTED';
export const PREVIEW_SCROLL_POSITION_CHANGED = 'PREVIEW_SCROLL_POSITION_CHANGED';
export const IFRAME_CLICKED = 'IFRAME_CLICKED';
export const SET_VALIDATION_POPOVER_OPEN = 'SET_VALIDATION_POPOVER_OPEN';
export const SET_CLICKED_VALIDATION_ERROR = 'SET_CLICKED_VALIDATION_ERROR';
export const MODULE_SET_LAYOUT_STYLES = 'MODULE_SET_LAYOUT_STYLES';
export const MODULE_RESET_LAYOUT_STYLES = 'MODULE_RESET_LAYOUT_STYLES';
export const LAYOUT_SECTION_COLUMN_INSERTED_AFTER = 'LAYOUT_SECTION_COLUMN_INSERTED_AFTER';
export const LAYOUT_SECTION_COLUMN_INSERTED_BEFORE = 'LAYOUT_SECTION_COLUMN_INSERTED_BEFORE';
export const LAYOUT_SECTION_INSERTED_IN_EMPTY_ROW = 'LAYOUT_SECTION_INSERTED_IN_EMPTY_ROW';
export const LAYOUT_SECTION_INSERTED_IN_EMPTY_COLUMN = 'LAYOUT_SECTION_INSERTED_IN_EMPTY_COLUMN';
export const LAYOUT_SECTION_ROW_APPENDED = 'LAYOUT_SECTION_ROW_APPENDED';
export const LAYOUT_SECTION_ROW_PREPENDED = 'LAYOUT_SECTION_ROW_PREPENDED';
export const LAYOUT_SECTION_ROW_INSERTED_AFTER = 'LAYOUT_SECTION_ROW_INSERTED_AFTER';
export const LAYOUT_SECTION_ROW_INSERTED_BEFORE = 'LAYOUT_SECTION_ROW_INSERTED_BEFORE';
export const LAYOUT_SECTION_ROW_CLONED_BELOW = 'LAYOUT_SECTION_ROW_CLONED_BELOW';
export const LAYOUT_SECTION_CELL_CLONED_TO_RIGHT = 'LAYOUT_SECTION_CELL_CLONED_TO_RIGHT';
export const LAYOUT_SECTION_COLUMNS_RESIZED = 'LAYOUT_SECTION_COLUMNS_RESIZED';
export const LAYOUT_SECTION_MODULE_DELETED = 'LAYOUT_SECTION_MODULE_DELETED';
export const LAYOUT_SECTION_ROW_DELETED = 'LAYOUT_SECTION_ROW_DELETED';
export const LAYOUT_SECTION_COLUMN_DELETED = 'LAYOUT_SECTION_COLUMN_DELETED';
export const LAYOUT_SECTION_SET_CELL_CSS_ID = 'LAYOUT_SECTION_SET_CELL_CSS_ID';
export const LAYOUT_SECTION_SET_CELL_CSS_STYLES = 'LAYOUT_SECTION_SET_CELL_CSS_STYLES';
export const LAYOUT_SECTION_SET_CELL_CSS_CLASS = 'LAYOUT_SECTION_SET_CELL_CSS_CLASS';
export const LAYOUT_SECTION_SET_ROW_CSS_CLASS = 'LAYOUT_SECTION_SET_ROW_CSS_CLASS';
export const LAYOUT_SECTION_SET_LAYOUT_LOCKED = 'LAYOUT_SECTION_SET_LAYOUT_LOCKED';
export const SET_TEMPLATE_AUTHOR_MODE = 'SET_TEMPLATE_AUTHOR_MODE';
export const LAYOUT_SECTION_ADD_CLASS_TO_CELL = 'LAYOUT_SECTION_ADD_CLASS_TO_CELL';
export const LAYOUT_SECTION_REMOVE_CLASS_FROM_CELL = 'LAYOUT_SECTION_REMOVE_CLASS_FROM_CELL';
export const LAYOUT_SECTION_CELL_SET_LAYOUT_STYLES = 'LAYOUT_SECTION_CELL_SET_LAYOUT_STYLES';
export const LAYOUT_SECTION_ROW_SET_LAYOUT_STYLES = 'LAYOUT_SECTION_ROW_SET_LAYOUT_STYLES';
export const LAYOUT_SECTION_ROW_SET_VERTICAL_ALIGNMENT = 'LAYOUT_SECTION_ROW_SET_VERTICAL_ALIGNMENT';
export const LAYOUT_SECTION_CELL_RESET_LAYOUT_STYLES = 'LAYOUT_SECTION_CELL_RESET_LAYOUT_STYLES';
export const LAYOUT_SECTION_ROW_RESET_LAYOUT_STYLES = 'LAYOUT_SECTION_ROW_RESET_LAYOUT_STYLES';
export const MOBILE_LAYOUT_SECTION_CELL_RESET_LAYOUT_STYLES = 'MOBILE_LAYOUT_SECTION_CELL_RESET_LAYOUT_STYLES';
export const MOBILE_LAYOUT_SECTION_ROW_RESET_LAYOUT_STYLES = 'MOBILE_LAYOUT_SECTION_ROW_RESET_LAYOUT_STYLES';
export const SELECTED_ROW_OR_COLUMN_UPDATED = 'SELECTED_ROW_OR_COLUMN_UPDATED';
export const UPDATE_COMPUTED_STYLES_FOR_SELECTORS = 'UPDATE_COMPUTED_STYLES_FOR_SELECTORS';
export const CLONED_MODULES_QUEUE_CLEARED = 'CLONED_MODULES_QUEUE_CLEARED';
export const CLONED_STATIC_SECTION_MAP_CLEARED = 'CLONED_STATIC_SECTION_MAP_CLEARED';
export const MAB_EXPERIMENT_MODAL_LOADING = 'MAB_EXPERIMENT_MODAL_LOADING';
export const MAB_EXPERIMENT_MODAL_LOADED = 'MAB_EXPERIMENT_MODAL_LOADED';
export const CLOSE_CLONE_REQUEST_MODAL = 'CLOSE_CLONE_REQUEST_MODAL';
export const LAYOUT_SECTION_REQUESTED_CLONE = 'LAYOUT_SECTION_REQUESTED_CLONE';
export const FETCH_REVISIONS_STARTED = 'FETCH_REVISIONS_STARTED';
export const FETCH_REVISIONS_SUCCEEDED = 'FETCH_REVISIONS_SUCCEEDED';
export const FETCH_REVISIONS_FAILED = 'FETCH_REVISIONS_FAILED';
export const FETCH_SCHEDULED_VERSION_STARTED = 'FETCH_SCHEDULED_VERSION_STARTED';
export const FETCH_SCHEDULED_VERSION_SUCCEEDED = 'FETCH_SCHEDULED_VERSION_SUCCEEDED';
export const FETCH_SCHEDULED_VERSION_FAILED = 'FETCH_SCHEDULED_VERSION_FAILED';
export const SET_CRITSIT_FLAGS = 'SET_CRITSIT_FLAGS';
export const FETCH_THEME_FAILED = 'FETCH_THEME_FAILED';
export const FETCH_THEME_STARTED = 'FETCH_THEME_STARTED';
export const FETCH_THEME_SUCCEEDED = 'FETCH_THEME_SUCCEEDED';
export const FETCH_CUSTOM_FONTS_SUCCEEDED = 'FETCH_CUSTOM_FONTS_SUCCEEDED';
export const FETCH_CUSTOM_FONTS_FAILED = 'FETCH_CUSTOM_FONTS_FAILED';
export const FETCH_CUSTOM_FONTS_STARTED = 'FETCH_CUSTOM_FONTS_STARTED';
export const UPDATED_TEST_FLAGS = 'UPDATED_TEST_FLAGS';
export const FETCH_EDITABLE_SLUG_INFO_REQUEST = 'FETCH_EDITABLE_SLUG_INFO_REQUEST';
export const FETCH_EDITABLE_SLUG_INFO_FAILED = 'FETCH_EDITABLE_SLUG_INFO_FAILED';
export const FETCH_EDITABLE_SLUG_INFO_SUCCESS = 'FETCH_EDITABLE_SLUG_INFO_SUCCESS';
export const FETCH_PORTAL_SCOPES_REQUEST = 'FETCH_PORTAL_SCOPES_REQUEST';
export const FETCH_PORTAL_SCOPES_SUCCESS = 'FETCH_PORTAL_SCOPES_SUCCESS';
export const FETCH_PORTAL_SCOPES_FAILED = 'FETCH_PORTAL_SCOPES_FAILED';
export const FETCH_PORTAL_INFO_REQUEST = 'FETCH_PORTAL_INFO_REQUEST';
export const FETCH_PORTAL_INFO_SUCCESS = 'FETCH_PORTAL_INFO_SUCCESS';
export const FETCH_PORTAL_INFO_FAILED = 'FETCH_PORTAL_INFO_FAILED';
export const FETCH_MULTI_DOMAIN_PUBLISHING_SCOPE_CHANGE_REQUEST = 'FETCH_MULTI_DOMAIN_PUBLISHING_SCOPE_CHANGE_REQUEST';
export const FETCH_MULTI_DOMAIN_PUBLISHING_SCOPE_CHANGE_FAILED = 'FETCH_MULTI_DOMAIN_PUBLISHING_SCOPE_CHANGE_FAILED';
export const FETCH_MULTI_DOMAIN_PUBLISHING_SCOPE_CHANGE_SUCCESS = 'FETCH_MULTI_DOMAIN_PUBLISHING_SCOPE_CHANGE_SUCCESS';
export const FETCH_HARD_SAVED_CONTENT_MODEL_STARTED = 'FETCH_HARD_SAVED_CONTENT_MODEL_STARTED';
export const FETCH_HARD_SAVED_CONTENT_MODEL_SUCCEEDED = 'FETCH_HARD_SAVED_CONTENT_MODEL_SUCCEEDED';
export const FETCH_HARD_SAVED_CONTENT_MODEL_FAILED = 'FETCH_HARD_SAVED_CONTENT_MODEL_FAILED';
export const FETCH_USERS_STARTED = 'FETCH_USERS_STARTED';
export const FETCH_USERS_SUCCEEDED = 'FETCH_USERS_SUCCEEDED';
export const FETCH_USERS_FAILED = 'FETCH_USERS_FAILED';
export const RELOAD_WITHOUT_WARNING = 'RELOAD_WITHOUT_WARNING';
export const FETCH_CUSTOM_DOMAINS_PURGE_REQUEST = 'FETCH_CUSTOM_DOMAINS_PURGE_REQUEST';
export const FETCH_CUSTOM_DOMAINS_PURGE_FAILED = 'FETCH_CUSTOM_DOMAINS_PURGE_FAILED';
export const FETCH_CUSTOM_DOMAINS_PURGE_SUCCESS = 'FETCH_CUSTOM_DOMAINS_PURGE_SUCCESS';
export const FETCH_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE_REQUEST = 'FETCH_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE_REQUEST';
export const FETCH_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE_FAILED = 'FETCH_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE_FAILED';
export const FETCH_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE_SUCCESS = 'FETCH_SITE_PAGES_PASSWORD_PROTECTION_PURGE_DATE_SUCCESS';
export const FETCH_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE_REQUEST = 'FETCH_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE_REQUEST';
export const FETCH_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE_FAILED = 'FETCH_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE_FAILED';
export const FETCH_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE_SUCCESS = 'FETCH_LANDING_PAGES_PASSWORD_PROTECTION_PURGE_DATE_SUCCESS';
export const FETCH_AUDIENCE_ACCESS_PURGE_DATE_REQUEST = 'FETCH_AUDIENCE_ACCESS_PURGE_DATE_REQUEST';
export const FETCH_AUDIENCE_ACCESS_PURGE_DATE_FAILED = 'FETCH_AUDIENCE_ACCESS_PURGE_DATE_FAILED';
export const FETCH_AUDIENCE_ACCESS_PURGE_DATE_SUCCESS = 'FETCH_AUDIENCE_ACCESS_PURGE_DATE_SUCCESS';
export const FETCH_HUBDB_PAGE_TEMPLATE_PURGE_DATE_REQUEST = 'FETCH_HUBDB_PAGE_TEMPLATE_PURGE_DATE_REQUEST';
export const FETCH_HUBDB_PAGE_TEMPLATE_PURGE_DATE_FAILED = 'FETCH_HUBDB_PAGE_TEMPLATE_PURGE_DATE_FAILED';
export const FETCH_HUBDB_PAGE_TEMPLATE_PURGE_DATE_SUCCESS = 'FETCH_HUBDB_PAGE_TEMPLATE_PURGE_DATE_SUCCESS';
export const SWITCH_TO_SMART_CONTENT_PREVIEW = 'SWITCH_TO_SMART_CONTENT_PREVIEW';
export const FETCH_BRAND_COLORS_STARTED = 'FETCH_BRAND_COLORS_STARTED';
export const FETCH_BRAND_COLORS_FAILED = 'FETCH_BRAND_COLORS_FAILED';
export const FETCH_BRAND_COLORS_SUCCEEDED = 'FETCH_BRAND_COLORS_SUCCEEDED';
export const TOGGLE_APPLY_CHANGES_MODAL_OPEN = 'TOGGLE_APPLY_CHANGES_MODAL_OPEN';
export const SET_SCROLL_TO_IN_MODULE_LIST = 'SET_SCROLL_TO_IN_MODULE_LIST';
export const DISMISS_SCOPES_HAVE_CHANGED_MODAL = 'DISMISS_SCOPES_HAVE_CHANGED_MODAL';
export const CLEAR_USE_SCROLL_IF_MODULE_OUT_OF_BOUNDS_AT_ALL = 'CLEAR_USE_SCROLL_IF_MODULE_OUT_OF_BOUNDS_AT_ALL';
export const SHOW_MATCHING_APP_MODAL = 'SHOW_MATCHING_APP_MODAL';
export const HIDE_MATCHING_APP_MODAL = 'HIDE_MATCHING_APP_MODAL';
export const OPEN_AUDIO_NARRATION_PANEL = 'OPEN_AUDIO_NARRATION_PANEL';
export const FETCH_ACCOUNT_VERIFICATION_STATUS_FAILED = 'FETCH_ACCOUNT_VERIFICATION_STATUS_FAILED';
export const FETCH_ACCOUNT_VERIFICATION_STATUS_STARTED = 'FETCH_ACCOUNT_VERIFICATION_STATUS_STARTED';
export const FETCH_ACCOUNT_VERIFICATION_STATUS_SUCCEEDED = 'FETCH_ACCOUNT_VERIFICATION_STATUS_SUCCEEDED';
export const SET_APPLY_CHANGES_BUTTON_OPEN = 'SET_APPLY_CHANGES_BUTTON_OPEN';
export const OPEN_SWAP_HEADER_MODAL = 'OPEN_SWAP_HEADER_MODAL';
export const CLOSE_SWAP_HEADER_MODAL = 'CLOSE_SWAP_HEADER_MODAL';
export const OPEN_SWAP_FOOTER_MODAL = 'OPEN_SWAP_FOOTER_MODAL';
export const CLOSE_SWAP_FOOTER_MODAL = 'CLOSE_SWAP_FOOTER_MODAL';
export const OPEN_SECTIONS_LIBRARY_MODAL = `OPEN_SECTIONS_LIBRARY_MODAL`;
export const CLOSE_SECTIONS_LIBRARY_MODAL = `CLOSE_SECTIONS_LIBRARY_MODAL`;
export const CLEAR_CURRENT_LAYOUT_SECTION_TO_ADD_TO = `CLEAR_CURRENT_LAYOUT_SECTION_TO_ADD_TO`;
export const OPEN_CREATE_NEW_SECTION_PANEL = `OPEN_CREATE_NEW_SECTION_PANEL`;
export const CLOSE_CREATE_NEW_SECTION_PANEL = `CLOSE_CREATE_NEW_SECTION_PANEL`;
export const OPEN_DELETE_SECTION_MODAL = `OPEN_DELETE_SECTION_MODAL`;
export const CLOSE_DELETE_SECTION_MODAL = `CLOSE_DELETE_SECTION_MODAL`;
export const SET_SECTIONS_LIBRARY_SEARCH_QUERY = 'SET_SECTIONS_LIBRARY_SEARCH_QUERY';
export const CLEAR_SECTIONS_LIBRARY_SEARCH_QUERY = 'CLEAR_SECTIONS_LIBRARY_SEARCH_QUERY';
export const FETCH_ADDABLE_SECTIONS_SUCCESS = 'FETCH_ADDABLE_SECTIONS_SUCCESS';
export const FETCH_ADDABLE_SECTIONS_FAILURE = 'FETCH_ADDABLE_SECTIONS_FAILURE';
export const FETCH_ADDABLE_SECTIONS_REQUEST = 'FETCH_ADDABLE_SECTIONS_REQUEST';
export const MARK_ADDABLE_SECTIONS_AS_STATE = 'MARK_ADDABLE_SECTIONS_AS_STATE';
export const DELETE_SECTION_SUCCESS = 'DELETE_SECTION_SUCCESS';
export const DELETE_SECTION_FAILURE = 'DELETE_SECTION_FAILURE';
export const DELETE_SECTION_REQUEST = 'DELETE_SECTION_REQUEST';
export const CUSTOM_LAYOUT_SECTION_ADDED = 'CUSTOM_LAYOUT_SECTION_ADDED';
export const UPDATE_CURRENT_LAYOUT_SECTION_TO_ADD_TO = 'UPDATE_CURRENT_LAYOUT_SECTION_TO_ADD_TO';
export const SAVE_SECTION_REQUEST = 'SAVE_SECTION_REQUEST';
export const SAVE_SECTION_SUCCESS = 'SAVE_SECTION_SUCCESS';
export const SAVE_SECTION_FAILURE = 'SAVE_SECTION_FAILURE';
export const FETCH_MARKETER_SECTIONS_REQUEST = 'FETCH_MARKETER_SECTIONS_REQUEST';
export const FETCH_MARKETER_SECTIONS_SUCCESS = 'FETCH_MARKETER_SECTIONS_SUCCESS';
export const FETCH_MARKETER_SECTIONS_FAILURE = 'FETCH_MARKETER_SECTIONS_FAILURE';
export const REDIRECT_TO_DELETE_SECTIONS = 'REDIRECT_TO_DELETE_SECTIONS';
export const SELECTED_FIELD_UPDATED = 'SELECTED_FIELD_UPDATED';
export const FETCH_DOMAIN_EXCLUSION_REASON_REQUEST = 'FETCH_DOMAIN_EXCLUSION_REASON_REQUEST';
export const FETCH_DOMAIN_EXCLUSION_REASON_SUCCESS = 'FETCH_DOMAIN_EXCLUSION_REASON_SUCCESS';
export const FETCH_DOMAIN_EXCLUSION_REASON_FAILURE = 'FETCH_DOMAIN_EXCLUSION_REASON_FAILURE';
export const ADD_TO_BUILT_IN_MAPPING = 'ADD_TO_BUILT_IN_MAPPING';
export const UPDATE_SELECTED_UPGRADABLE_MODULE_PQL = 'UPDATE_SELECTED_UPGRADABLE_MODULE_PQL';
export const ACTIVATE_DEVELOPER_MODE = 'ACTIVATE_DEVELOPER_MODE';
export const SET_ADD_SECTION_MISSING_MODULE_ERRORS = 'SET_ADD_SECTION_MISSING_MODULE_ERRORS';
export const CLEAR_ADD_SECTION_MISSING_MODULE_ERRORS = 'CLEAR_ADD_SECTION_MISSING_MODULE_ERRORS';

// Fetch Generated HubL for layout fragment info
export const FETCH_GENERATED_LAYOUT_HUBL_SUCCESS = 'FETCH_GENERATED_LAYOUT_HUBL_SUCCESS';
export const FETCH_GENERATED_LAYOUT_HUBL_FAILURE = 'FETCH_GENERATED_LAYOUT_HUBL_FAILURE';
export const FETCH_GENERATED_LAYOUT_HUBL_STARTED = 'FETCH_GENERATED_LAYOUT_HUBL_STARTED';

//Email Template Editor
export const FETCH_TEMPLATE_SCHEMA_FAILED = 'FETCH_TEMPLATE_SCHEMA_FAILED';
export const FETCH_TEMPLATE_SCHEMA_STARTED = 'FETCH_TEMPLATE_SCHEMA_STARTED';
export const FETCH_TEMPLATE_SCHEMA_SUCCEEDED = 'FETCH_TEMPLATE_SCHEMA_SUCCEEDED';
export const UNIVERSAL_APP_IS_READY = 'UNIVERSAL_APP_IS_READY';
export const UPDATE_STATIC_MODULE_WITH_NEW_ID = 'UPDATE_STATIC_MODULE_WITH_NEW_ID';
export const UPDATE_NOPE_ZONE_SELECTOR = 'UPDATE_NOPE_ZONE_SELECTOR';
export const UPDATE_PREVIEW_URL = 'UPDATE_PREVIEW_URL';
export const FLUSH_SIDEBAR_HIDDEN_STATE = 'FLUSH_SIDEBAR_HIDDEN_STATE';

// SEO Settings Popover
export const SET_SETTING_OPTIMIZATION_TYPE = 'SET_SETTING_OPTIMIZATION_TYPE';

// Contents Sidebar Tree View actions
export const CLOSE_TREE_NODES = 'CLOSE_TREE_NODES';
export const OPEN_TREE_NODES = 'OPEN_TREE_NODES';
export const RESET_LAYOUT_SECTION_TO_TEMPLATE_DEFAULT = 'RESET_LAYOUT_SECTION_TO_TEMPLATE_DEFAULT';
export const SET_SIDEBAR_SEARCH_TERM = 'SET_SIDEBAR_SEARCH_TERM';
export const SET_SIDEBAR_ACTIVE_MATCH = 'SET_SIDEBAR_ACTIVE_MATCH';
export const SET_SIDEBAR_MATCH_IDS = 'SET_SIDEBAR_MATCH_IDS';
export const OPEN_EXPANDABLE_MENU = 'OPEN_EXPANDABLE_MENU';
export const CLEAR_OPEN_EXPANDABLE_MENU = 'CLEAR_OPEN_EXPANDABLE_MENU';
export const SAVE_SIDEBAR_SCROLL_TOP = 'SAVE_SIDEBAR_SCROLL_TOP';
export const SHOW_ALL_ROWS_FOR_DND_AREA = 'SHOW_ALL_ROWS_FOR_DND_AREA';
export const SHOW_STANDARD_ROWS_FOR_DND_AREA = 'SHOW_STANDARD_ROWS_FOR_DND_AREA';

//patagonia sidebar actions
export const SELECTED_CATEGORY_UPDATE = 'SELECTED_CATEGORY_UPDATE';
export const SELECTED_SUB_CATEGORY_UPDATE = 'SELECTED_SUB_CATEGORY_UPDATE';
export const SET_PATAGONIA_ACTIVE_PANEL = 'SET_PATAGONIA_ACTIVE_PANEL';
export const UPDATE_SIDEBAR_SEARCH_QUERY = 'UPDATE_SIDEBAR_SEARCH_QUERY';
export const UPDATE_PATAGONIA_SETTINGS_MODAL_ACTIVE_NAV_ITEM = 'UPDATE_PATAGONIA_SETTINGS_MODAL_ACTIVE_NAV_ITEM';
// X-Ray optimization actions
export const SET_XRAY_PAGE_TITLE = 'SET_XRAY_PAGE_TITLE';
export const SET_XRAY_META_DESC = 'SET_XRAY_META_DESC';
export const SET_XRAY_READABILITY = 'SET_XRAY_READABILITY';
export const CLEAR_XRAY_READABILITY = 'CLEAR_XRAY_READABILITY';
export const SET_XRAY_INPAGE_GATHERER_ARTIFACTS = 'SET_XRAY_INPAGE_GATHERER_ARTIFACTS';
export const SET_XRAY_INPAGE_GATHERER_KEYS = 'SET_XRAY_INPAGE_GATHERER_KEYS';
export const FREEZE_NODE_POSITIONS = 'FREEZE_NODE_POSITIONS';
export const THAW_NODE_POSITIONS = 'THAW_NODE_POSITIONS';
export const UPDATE_COLLABORATION_SIDEBAR_STATE = 'UPDATE_COLLABORATION_SIDEBAR_STATE';
export const UPDATE_HEADER_ACTIVE_ITEM = 'UPDATE_HEADER_ACTIVE_ITEM';
export const SHOULD_CLEAR_HEADER_ACTIVE_ITEM = 'SHOULD_CLEAR_HEADER_ACTIVE_ITEM';
export const LOCATION_CHANGE = 'LOCATION_CHANGE';
export const HISTORY_METHOD_CALLED = 'HISTORY_METHOD_CALLED';
export const SET_ACTIVE_HUBDB_ROW = 'SET_ACTIVE_HUBDB_ROW';
export const CLEAR_ACTIVE_HUBDB_ROW = 'CLEAR_ACTIVE_HUBDB_ROW';
export const SET_HUBDB_ROWS_AND_SCHEMA = 'SET_HUBDB_ROWS_AND_SCHEMA';
export const UPDATE_TABLE_ROWS = 'UPDATE_TABLE_ROWS';
export const SET_IS_INLINE_FIELD_FOCUSED = 'SET_IS_INLINE_FIELD_FOCUSED';
export const UPDATE_DATA_AUTHORING_MODE = 'UPDATE_DATA_AUTHORING_MODE';
export const UPDATE_CELL_ATTEMPTED = 'UPDATE_CELL_ATTEMPTED';
export const UPDATE_CELL_SUCCEEDED = 'UPDATE_CELL_SUCCEEDED';
export const UPDATE_ROW_ATTEMPTED = 'UPDATE_ROW_ATTEMPTED';
export const UPDATE_ROW_SUCCEEDED = 'UPDATE_ROW_SUCCEEDED';
export const FETCH_EMBEDS_STARTED = 'FETCH_EMBEDS_STARTED';
export const FETCH_EMBEDS_SUCCEEDED = 'FETCH_EMBEDS_SUCCEEDED';
export const FETCH_EMBEDS_FAILED = 'FETCH_EMBEDS_FAILED';
export const ADD_NEW_EMBED_TO_EMBED_INFO = 'ADD_NEW_EMBED_TO_EMBED_INFO';
export const REMOVE_EMBED_FROM_EMBED_INFO = 'REMOVE_EMBED_FROM_EMBED_INFO';
export const SET_TEST_TYPE = 'SET_TEST_TYPE';
export const PUBLISH_ACTION_FAILED = 'PUBLISH_ACTION_FAILED';
export const PUBLISH_ACTION_LOADING = 'PUBLISH_ACTION_LOADING';
// content assistant
export const GET_CONTENT_ASSISTANT_SETTINGS = 'GET_CONTENT_ASSISTANT_SETTINGS';
export const GET_BRAND_VOICE_SETTINGS = 'GET_BRAND_VOICE_SETTINGS';
export const GET_BRAND_VOICE_SETTINGS_NOT_FOUND = 'GET_BRAND_VOICE_SETTINGS_NOT_FOUND';

// CMS Settings datastore
export const FETCH_CMS_SETTINGS_STARTED = 'FETCH_CMS_SETTINGS_STARTED';
export const FETCH_CMS_SETTINGS_SUCCESS = 'FETCH_CMS_SETTINGS_SUCCESS';
export const FETCH_CMS_SETTINGS_FAILURE = 'FETCH_CMS_SETTINGS_FAILURE';
export const UPDATE_HAS_DISMISSED_ONE_CLICK_PUBLISH_TOUR_CMS_SETTING_LOCALLY = 'UPDATE_HAS_DISMISSED_ONE_CLICK_PUBLISH_TOUR_CMS_SETTING_LOCALLY';

// module version info
export const FETCH_MODULE_VERSIONS_STARTED = 'FETCH_MODULE_VERSIONS_STARTED';
export const FETCH_MODULE_VERSIONS_SUCCESS = 'FETCH_MODULE_VERSIONS_SUCCESS';
export const FETCH_MODULE_VERSIONS_FAILURE = 'FETCH_MODULE_VERSIONS_FAILURE';
export const SET_CRM_OBJECTS_TO_EDIT = 'SET_CRM_OBJECTS_TO_EDIT';
export const UPDATE_CRM_OBJECT_PROPERTY = 'UPDATE_CRM_OBJECT_PROPERTY';
export const FETCH_CRM_OBJECT_FIELD_SCHEMA_SUCCEEDED = 'FETCH_CRM_OBJECT_FIELD_SCHEMA_SUCCEEDED';
export const CLEAR_MODIFIED_PATHS_WAITING_TO_SAVE = 'CLEAR_MODIFIED_PATHS_WAITING_TO_SAVE';
export const SET_MODIFIED_PATHS_WAITING_TO_SAVE = 'SET_MODIFIED_PATHS_WAITING_TO_SAVE';
// template context
export const SET_MODULE_TEMPLATE_CONTEXT = 'SET_MODULE_TEMPLATE_CONTEXT';
export const SET_MODULE_TEMPLATE_CONTEXT_PROPERTY = 'SET_MODULE_TEMPLATE_CONTEXT_PROPERTY';

// ab test
export const UPDATE_AB_TEST_MASTER_NAME = 'UPDATE_AB_TEST_MASTER_NAME';
export const UPDATE_AB_TEST_VARIATION_NAME = 'UPDATE_AB_TEST_VARIATION_NAME';
export const UPDATE_AB_TEST_VARIANT_SUBJECT = 'UPDATE_AB_TEST_VARIANT_SUBJECT';
export const UPDATE_AB_TEST_VARIANT_AI_FEATURES = 'UPDATE_AB_TEST_VARIANT_AI_FEATURES';
export const SET_AI_PERSONALIZATION_KEY = 'SET_AI_PERSONALIZATION_KEY';
export const REPLACE_AI_PERSONALIZATION_KEYS = 'REPLACE_AI_PERSONALIZATION_KEYS';
export const UPDATE_IS_TRELLIS_THEME = 'UPDATE_IS_TRELLIS_THEME';
export const SET_GRID_LAYOUTS = 'SET_GRID_LAYOUTS';
export const GRID_LAYOUTS_SET_NODE_STYLES = 'GRID_LAYOUTS_SET_NODE_STYLES';
export const GRID_LAYOUTS_UPDATE_NODE_LAYOUT = 'GRID_LAYOUTS_UPDATE_NODE_LAYOUT';
export const GRID_LAYOUTS_UPDATE_TABLE_DEFINITION = 'GRID_LAYOUTS_UPDATE_TABLE_DEFINITION';
export const GRID_LAYOUTS_ROW_SET_LAYOUT_STYLES = 'GRID_LAYOUTS_ROW_SET_LAYOUT_STYLES';
export const GRID_LAYOUTS_COLUMN_SET_LAYOUT_STYLES = 'GRID_LAYOUTS_COLUMN_SET_LAYOUT_STYLES';
export const GRID_LAYOUTS_TABLE_SET_LAYOUT_STYLES = 'GRID_LAYOUTS_TABLE_SET_LAYOUT_STYLES';
export const GRID_LAYOUTS_APPENDED_GRID_CELL = 'GRID_LAYOUTS_APPENDED_GRID_CELL';
export const GRID_LAYOUTS_INSERTED_AFTER_TABLE_CELL = 'GRID_LAYOUTS_INSERTED_AFTER_TABLE_CELL';
export const GRID_LAYOUTS_ROW_CLONED_BELOW = 'GRID_LAYOUTS_ROW_CLONED_BELOW';
export const GRID_LAYOUTS_CELL_CLONED_TO_RIGHT = 'GRID_LAYOUTS_CELL_CLONED_TO_RIGHT';
export const GRID_LAYOUTS_NODE_CLONED_AND_INSERTED_AFTER_ORIGINAL = 'GRID_LAYOUTS_NODE_CLONED_AND_INSERTED_AFTER_ORIGINAL';
export const GRID_LAYOUTS_COLUMNS_RESIZED = 'GRID_LAYOUTS_COLUMNS_RESIZED';
export const GRID_LAYOUTS_MODULE_DELETED = 'GRID_LAYOUTS_MODULE_DELETED';
export const GRID_LAYOUTS_CONTAINER_DELETED = 'GRID_LAYOUTS_CONTAINER_DELETED';
export const GRID_LAYOUTS_SECTION_DELETED = 'GRID_LAYOUTS_SECTION_DELETED';
export const WRAP_IN_STACK = 'WRAP_IN_STACK';
export const GRID_LAYOUTS_ELEMENT_APPENDED = 'GRID_LAYOUTS_ELEMENT_APPENDED';
export const GRID_LAYOUTS_ELEMENT_PREPENDED = 'GRID_LAYOUTS_ELEMENT_PREPENDED';
export const GRID_LAYOUTS_ELEMENT_INSERTED_BEFORE = 'GRID_LAYOUTS_ELEMENT_INSERTED_BEFORE';
export const GRID_LAYOUTS_ELEMENT_INSERTED_AFTER = 'GRID_LAYOUTS_ELEMENT_INSERTED_AFTER';
export const GRID_LAYOUTS_INSERTED_IN_EMPTY_STACK = 'GRID_LAYOUTS_INSERTED_IN_EMPTY_STACK';
export const GRID_LAYOUTS_INSERTED_IN_EMPTY_GRID_LAYOUT = 'GRID_LAYOUTS_INSERTED_IN_EMPTY_GRID_LAYOUT';
export const GRID_LAYOUTS_INSERTED_IN_TABLE_CELL = 'GRID_LAYOUTS_INSERTED_IN_TABLE_CELL';
export const GRID_LAYOUTS_MOVE_SECTION_AFTER = 'GRID_LAYOUTS_MOVE_SECTION_AFTER';
export const GRID_LAYOUTS_MOVE_SECTION_BEFORE = 'GRID_LAYOUTS_MOVE_SECTION_BEFORE';
export const GRID_LAYOUTS_WRAP_AND_INSERT_ABOVE_CONTAINER = 'GRID_LAYOUTS_WRAP_AND_INSERT_ABOVE_CONTAINER';
export const GRID_LAYOUTS_WRAP_AND_INSERT_BELOW_CONTAINER = 'GRID_LAYOUTS_WRAP_AND_INSERT_BELOW_CONTAINER';
export const GRID_LAYOUTS_WRAP_AND_INSERT_LEFT_OF_CONTAINER = 'GRID_LAYOUTS_WRAP_AND_INSERT_LEFT_OF_CONTAINER';
export const GRID_LAYOUTS_WRAP_AND_INSERT_RIGHT_OF_CONTAINER = 'GRID_LAYOUTS_WRAP_AND_INSERT_RIGHT_OF_CONTAINER';
export const FETCH_GRIDS_BUFFERS_FOR_OBJECT_ID_STARTED = 'FETCH_GRIDS_BUFFERS_FOR_OBJECT_ID_STARTED';
export const FETCH_GRIDS_BUFFERS_FOR_OBJECT_ID_FAILED = 'FETCH_GRIDS_BUFFERS_FOR_OBJECT_ID_FAILED';
export const FETCH_GRIDS_BUFFERS_FOR_OBJECT_ID_SUCCEEDED = 'FETCH_GRIDS_BUFFERS_FOR_OBJECT_ID_SUCCEEDED';
export const GRIDS_SAVE_REQUEST_STARTED = 'GRIDS_SAVE_REQUEST_STARTED';
export const GRIDS_SAVE_REQUEST_SUCCEEDED = 'GRIDS_SAVE_REQUEST_SUCCEEDED';
export const GRIDS_SAVE_REQUEST_FAILED = 'GRIDS_SAVE_REQUEST_FAILED';
export const GRID_LAYOUTS_INSERT_BLANK_SECTION = 'GRID_LAYOUTS_INSERT_BLANK_SECTION';
export const GRID_SET_OLD_MODULE_STYLES = 'GRID_SET_OLD_MODULE_STYLES';
export const GRID_LAYOUTS_SET_LABEL = 'GRID_LAYOUTS_SET_LABEL';
export const GRID_LAYOUTS_DROP_ON_PEGBOARD = 'GRID_LAYOUTS_DROP_ON_PEGBOARD';